import React from 'react';
import {List} from "convertupleads-theme";
import EachList from "./EachList";
import {ALL_DATA_LISTS} from "../../helpers/sidebarListConstant";

const ElementList = () => {
    const [selectedTitle, setSelectedTitle] = React.useState("");
    return (
        <>
            <List
                sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}
                component="nav"
                aria-labelledby="nested-list-subheader"
            >
                {ALL_DATA_LISTS.map((allElement)=>(
                    <EachList title={allElement?.title} selectedTitle={selectedTitle} onSelectTitle={setSelectedTitle} submenu={allElement?.subMenu} />
                ))}

            </List>
        </>
    );
};

export default ElementList;